<template>
  <div class="home">
    <NavbarMain />
    <h1 class="text-center mb-5 mt-5">Vender un servicio</h1>
    <div class="container mt-5">
      <DetailPublication
        kind="servicio"
        :name="product.name"
        :description="product.description"
        :categorySelected="product.category._id"
        v-on:handleChangeName="handleChangeName"
        v-on:handleChangeDescription="handleChangeDescription"
        v-on:handleChangeCategory="handleChangeCategory"
      />

      <SpecsPublication
        kind="servicio"
        :productSpecs="product.specs"
        v-on:handleChangeSpec="handleChangeSpec"
        v-on:initSpecs="initSpecs"
      />

      <ImagesPublication
        :images="product.images"
        :id="product._id"
        kind="servicio"
        v-on:handleChangeFileImages="handleChangeFileImages"
      />

      <VideoPublication
        :videoYT="product.videoYT"
        v-on:handleChangeVideoYT="handleChangeVideoYT"
      />

      <SellerPlacePublication
        kind="servicio"
        :sellerPlaceWorld="product.sellerPlaceWorld"
        :sellerPlaces="product.sellerPlaces"
        :CityOfSale="product.CityOfSale"
        :currency="product.currency"
        v-on:handleChangeTypePlace="handleChangeTypePlace"
      />

      <PricePublication
        kind="servicio"
        :currency="product.currency"
        :price="product.price"
        :discount="product.discount"
        :amount="product.amount"
        :comision="COMISSION"
        v-on:handleChangePrice="handleChangePrice"
        v-on:handleChangeCurrency="handleChangeCurrency"
        v-on:handleChangeDiscount="handleChangeDiscount"
      />

      <div class="form-group form-check mt-5">
        <input type="checkbox" class="form-check-input" v-model="checkTC" />
        <label class="form-check-label">
          Acepto las términos y condiciones como vendedor y me sujeto a las
          formas de pago y comisiones que determina la plataforma,
          <a href="#" class="terminos-y-condiciones"
            >ver términos y condiciones de vendedor</a
          >.
        </label>
      </div>
      <p
        class="text-danger alert alert-danger text-center pt-2"
        :class="pWarningTC ? '' : 'd-none'"
      >
        Debe aceptar los términos y condiciones de vendedor
      </p>
      <p
        class="text-danger alert alert-danger text-center pt-2"
        v-show="errorMesagge"
      >
        {{ errorMesagge }}
      </p>
      <span class="btn btn-block btn-treid mb-5" v-show="onload">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </span>
      <span
        v-show="!onload"
        class="btn btn-block btn-treid mb-5"
        @click="sellProduct"
        >Publicar</span
      >
    </div>
    <ModalNotify
      :visible="modalNotify.visible"
      :success="modalNotify.success"
      :title="modalNotify.title"
      :body="modalNotify.body"
      :acept="modalNotify.acept"
      :return="modalNotify.return"
      v-on:click="handleClickModal"
      v-on:clickReturn="handleCloseModal"
    />
    <ModalRefreshToken />
  </div>
</template>
<script>
import Api from "../../tools/Api2";
import NavbarMain from "@/components/NavbarMain.vue";
import ModalNotify from "../../components/modals/ModalNotify";
import { mapState } from "vuex";
import DetailPublication from "../../components/publication/DetailPublication.vue";
import SpecsPublication from "../../components/publication/SpecsPublication.vue";
import VideoPublication from "../../components/publication/VideoPublication.vue";
import SellerPlacePublication from "../../components/publication/SellerPlacePublication.vue";
import PricePublication from "../../components/publication/PricePublication.vue";
import ImagesPublication from "../../components/publication/ImagesPublication.vue";
import ModalRefreshToken from "../../components/modals/ModalRefreshToken.vue";
import { COMISSION } from "../../configs/contants";

export default {
  name: "SellService",
  components: {
    NavbarMain,
    ModalNotify,
    DetailPublication,
    SpecsPublication,
    VideoPublication,
    SellerPlacePublication,
    PricePublication,
    ImagesPublication,
    ModalRefreshToken,
  },
  data() {
    return {
      COMISSION,
      checkTC: false,
      pWarningTC: false,
      errorMesagge: "",
      product: {
        category: {
          _id: "",
          crr: 0,
        },
        shippingPrice: 0,
        shippingType: 1,
        currency: "MXN",
        amount: 1,
        description: "",
        name: "",
        price: 0,
        images: [],
        discount: 0,
        specs: [],
        videoYT: "",
        sellerPlaceWorld: false,
        sellerPlaces: ["MEX"],
        CityOfSale: "",
      },
      fileImages: [],
      modalNotify: {
        visible: false,
        success: true,
        title: "Servicio publicado con éxito!",
        body:
          "Su publicación está siendo revisada por un administrador de TreidBlue, le avisaremos cuando su publicación se encuentre aprobada.",
        return: false,
        redirect: "/mis-publicaciones",
        acept: true,
      },
      onload: false,
    };
  },
  methods: {
    sellProduct() {
      this.errorMesagge = "";
      if (!this.checkTC) return (this.pWarningTC = true);

      this.pWarningTC = false;

      if (!this.product.name) {
        this.errorMesagge = "Por favor, ponle un título a la publicación.";
        return;
      }

      if (!this.product.price) {
        this.errorMesagge = "Por favor, ponle un precio a la publicación.";
        return;
      }

      if (!this.product.description) {
        this.errorMesagge =
          "Por favor, ponle una descripción a la publicación.";
        return;
      }

      const specs = this.product.specs
        .filter((e) => e.cheked)
        .map((e) => {
          return {
            value: e.value,
            options: e.selectable ? e.options : "",
            formCategory: e._id,
          };
        });
      for (let spec of specs) {
        if (!spec.value && !spec.options.length) {
          this.errorMesagge =
            "Una de las caracteristicas seleccionadas se encuentra en blanco, por favor eliminar la caracteristica o completar con un valor.";
          return;
        }
      }

      this.onload = true;

      Api("service")
        .post({
          ...this.product,
          category: this.product.category._id,
          urlImages: [],
          specs,
        })
        .then((res) => {
          if (res.error) {
            this.onload = false;
            this.errorMesagge = res.message;
            return;
          }
          Api("service")
            .useFormData.put(res.id, { urlImages: [] }, this.fileImages)
            .then((res) => {
              this.onload = false;
              if (!res.error) return (this.modalNotify.visible = true);
              this.errorMesagge = res.message;
            })
            .catch((err) => {
              this.onload = false;
              this.errorMesagge = err.message;
            });
        })
        .catch((err) => {
          this.onload = false;
          this.errorMesagge = err.message;
        });
    },
    handleChangeName(name) {
      this.product.name = name;
    },
    handleChangeDescription(description) {
      this.product.description = description;
    },
    handleChangeCategory(category) {
      this.product.category = category;
    },
    handleChangeVideoYT(videoYT) {
      this.product.videoYT = videoYT;
    },
    handleChangeTypePlace({ sellerPlaceWorld, sellerPlaces, CityOfSale }) {
      this.product.sellerPlaceWorld = sellerPlaceWorld;
      this.product.sellerPlaces = sellerPlaces;
      this.product.CityOfSale = CityOfSale;
    },
    handleChangePrice(price) {
      this.product.price = price;
    },
    handleChangeCurrency(currency) {
      this.product.currency = currency;
    },
    handleChangeDiscount(discount) {
      if (discount > 100) return (this.product.discount = 100);

      if (discount < 0) return (this.product.discount = 0);

      this.product.discount = Number(discount);
    },
    handleChangeFileImages(images) {
      this.fileImages = images;
    },
    initSpecs(specs) {
      this.product.specs = specs;
    },
    handleChangeSpec(position, spec) {
      this.product.specs[position] = {
        ...this.product.specs[position],
        ...spec,
      };
    },
    handleCloseModal() {
      this.modalNotify.visible = false;
    },
    handleClickModal() {
      this.$router.push({ name: "Publications" });
    },
  },
  computed: {
    ...mapState(["auth"]),
  },
  created: async function() {
    if (this.auth.posicion == "Usuario") {
      this.$router.push({ name: "Home" });
    }
  },
};
</script>

<style scoped>
.form-group-treid {
  padding: 3em 1em !important;
  border-radius: 0.5em !important;
  background-color: white !important;
}

.container-form-treid {
  padding: 1em 3em 1em 3em;
}

.terminos-y-condiciones {
  color: #2a5ca7;
}

input,
textarea,
select {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

#file {
  box-shadow: none !important;
}
</style>
